export default {
  getColorCodes() {
    // Update variables if changed.
    return [
      { score: "1", color: "#FCAB9C", description: "Least Developed" },
      { score: "2", color: "#FFCA82", description: "" },
      { score: "3", color: "#FFE180", description: "" },
      { score: "4", color: "#80E1CC", description: "" },
      { score: "5", color: "#01C975", description: "Most Developed" },
      { score: "NA", color: "#6C757D" },
    ];
  },
};
